import { api } from '@creditsights/api-ui-web';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchMedia = async (module, path) => {
  const { data } = await api.get(`common/v1/media/${encodeURIComponent(module)}/${encodeURIComponent(path)}`);
  return data;
};
